import { Component, Injector, Input, OnInit, ViewChild, ViewEncapsulation, Renderer2, EventEmitter, Output } from '@angular/core';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { CommonDataModel } from '../common-data-model';
import { GridComponent } from '@progress/kendo-angular-grid';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
const hasClass = (el, className) => new RegExp(className).test(el.className);
const isChildOf = (el, className) => {
    while (el && el.parentElement) {
        if (hasClass(el.parentElement, className)) {
            return true;
        }
        el = el.parentElement;
    }
    return false;
};

@Component({
    selector: 'app-orders-item-spacing',
    templateUrl: './orders-item-spacing.component.html',
    styleUrls: ['./orders-item-spacing.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OrdersItemSpacingComponent extends AppComponentBase implements OnInit {

    @ViewChild('grid', { static: true }) private grid: GridComponent;
    @ViewChild('itemSpacingForm', { static: false }) itemSpacingForm: NgForm;
    @Output() emitEnableSaveButton: EventEmitter<any> = new EventEmitter();
    @Output() collapseEmit: EventEmitter<any> = new EventEmitter();
    @Input() isExpanded: any;
    @Input() readOnly: boolean;
    commonDatModel = new CommonDataModel();
    ischeckAll = false;
    spaceCheckBox = Object.assign({}, this.commonDatModel.itemSpacingModel);
    gridItems: any = {
        data: [Object.assign({}, this.commonDatModel.itemSpacingModel)],
        total: 0
    };
    isDisabledForm = false;

    constructor(
        injector: Injector,
        private renderer: Renderer2,
        private toastr: ToastrService,
    ) {
        super(injector);
        this.renderer.listen(
            'document',
            'click',
            ({ target }) => {
                if (!isChildOf(target, 'itemSpacingGrid')) {
                    this.grid.closeRow(0);
                    this.emitEnableSaveButton.emit();
                }
            });
    }

    ngOnInit() {
    }

    openAccordian(open: string, state: boolean) {
        if (open) {
            this.isExpanded = state;
            this.collapseEmit.emit();
        }
    }

    closeAccordian(open: string, state: boolean) {
        if (close) {
            this.isExpanded = state;
            this.collapseEmit.emit();
        }
    }

    onCellClickHandler(event: any) {
        if (!this.isDisabledForm) {
            if (!event.sender.isEdited && this.faceCheck(event.column.field)) {
                event.sender.editCell(event.rowIndex, event.columnIndex);
            }
        }
    }

    setCheckAllCheckbox() {
        if (this.gridItems && this.gridItems.data && this.gridItems.data.length > 0) {
            const firstItem = this.gridItems.data[0];
            this.spaceCheckBox.isTop = firstItem.isTop;
            this.spaceCheckBox.isBottom = firstItem.isBottom;
            this.spaceCheckBox.isSideOne = firstItem.isSideOne;
            this.spaceCheckBox.isSideTwo = firstItem.isSideTwo;
            this.spaceCheckBox.isEndOne = firstItem.isEndOne;
            this.spaceCheckBox.isEndtwo = firstItem.isEndtwo;
            this.ischeckAll = this.spaceCheckBox.isTop && this.spaceCheckBox.isBottom &&
                this.spaceCheckBox.isSideOne && this.spaceCheckBox.isSideTwo &&
                this.spaceCheckBox.isEndOne && this.spaceCheckBox.isEndtwo;
        } else {
            this.ischeckAll = false;
        }
    }

    onSetGridItemCheckbox() {
        this.gridItems.data[0].isTop = this.spaceCheckBox.isTop;
        this.gridItems.data[0].isBottom = this.spaceCheckBox.isBottom;
        this.gridItems.data[0].isSideOne = this.spaceCheckBox.isSideOne;
        this.gridItems.data[0].isSideTwo = this.spaceCheckBox.isSideTwo;
        this.gridItems.data[0].isEndOne = this.spaceCheckBox.isEndOne;
        this.gridItems.data[0].isEndtwo = this.spaceCheckBox.isEndtwo;
        this.setCheckAllCheckbox();
    }

    onfaceCheckChange(event: any, faceId: number) {
        if (this.gridItems.data.length > 0) {
            this.onSetGridItemCheckbox();
            this.itemSpacingForm.form.markAsDirty();
            this.emitEnableSaveButton.emit();
            if (event.checked) {
                this.enableFace(faceId);
            }
        }
    }

    enableFace(faceId: number) {
        switch (faceId) {
            case 1: {
                this.gridItems.data[0].isEndOne = true;
                break;
            }
            case 2: {
                this.gridItems.data[0].isEndtwo = true;
                break;
            }
            case 3: {
                this.gridItems.data[0].isSideOne = true;
                break;
            }
            case 4: {
                this.gridItems.data[0].isSideTwo = true;
                break;
            }
            case 5: {
                this.gridItems.data[0].isTop = true;
                break;
            }
            case 6: {
                this.gridItems.data[0].isBottom = true;
                break;
            }
        }
    }

    onAddSpacing() {
        if (this.spaceCheckBox.isTop || this.spaceCheckBox.isBottom || this.spaceCheckBox.isSideOne ||
            this.spaceCheckBox.isSideTwo || this.spaceCheckBox.isEndOne || this.spaceCheckBox.isEndtwo) {
            this.updateSpacing(1);
            this.itemSpacingForm.form.markAsDirty();
            this.emitEnableSaveButton.emit();
        } else {
            this.toastr.error(`Please select atleast 1 face`);
        }

    }

    onSubtractSpacing() {
        this.updateSpacing(-1);
        this.itemSpacingForm.form.markAsDirty();
        this.emitEnableSaveButton.emit();
    }

    updateSpacing(value: number) {
        if (this.gridItems.data && this.gridItems.data.length > 0) {
            if (this.spaceCheckBox.isBottom && (value === 1 || value === -1 && this.gridItems.data[0].bottom > 0)) {
                let subtractedValue = parseFloat(((+this.gridItems.data[0].bottom) + value).toFixed(3));
                this.gridItems.data[0].bottom = (subtractedValue > 0) ? subtractedValue : 0;
            }
            if (this.spaceCheckBox.isEndOne && (value === 1 || value === -1 && this.gridItems.data[0].endOne > 0)) {
                let subtractedValue = parseFloat(((+this.gridItems.data[0].endOne) + value).toFixed(3));
                this.gridItems.data[0].endOne = (subtractedValue > 0) ? subtractedValue : 0;
            }
            if (this.spaceCheckBox.isEndtwo && (value === 1 || value === -1 && this.gridItems.data[0].endtwo > 0)) {
                let subtractedValue = parseFloat(((+this.gridItems.data[0].endtwo) + value).toFixed(3));
                this.gridItems.data[0].endtwo = (subtractedValue > 0) ? subtractedValue : 0;
            }
            if (this.spaceCheckBox.isSideOne && (value === 1 || value === -1 && this.gridItems.data[0].sideOne > 0)) {
                let subtractedValue = parseFloat(((+this.gridItems.data[0].sideOne) + value).toFixed(3));
                this.gridItems.data[0].sideOne = (subtractedValue > 0) ? subtractedValue : 0;
            }
            if (this.spaceCheckBox.isSideTwo && (value === 1 || value === -1 && this.gridItems.data[0].sideTwo > 0)) {
                let subtractedValue = parseFloat(((+this.gridItems.data[0].sideTwo) + value).toFixed(3));
                this.gridItems.data[0].sideTwo = (subtractedValue > 0) ? subtractedValue : 0;
            }
            if (this.spaceCheckBox.isTop && (value === 1 || value === -1 && this.gridItems.data[0].top > 0)) {
                let subtractedValue = parseFloat(((+this.gridItems.data[0].top) + value).toFixed(3));
                this.gridItems.data[0].top = (subtractedValue > 0) ? subtractedValue : 0;
            }
        }
    }

    faceCheck(face: string) {
        switch (face) {
            case 'endOne': {
                return this.spaceCheckBox.isEndOne;
            }
            case 'endtwo': {
                return this.spaceCheckBox.isEndtwo;
            }
            case 'sideOne': {
                return this.spaceCheckBox.isSideOne;
            }
            case 'sideTwo': {
                return this.spaceCheckBox.isSideTwo;
            }
            case 'top': {
                return this.spaceCheckBox.isTop;
            }
            case 'bottom': {
                return this.spaceCheckBox.isBottom;
            }
            default: {
                return false;
            }
        }
    }

    resetFace(faceId: number) {
        switch (faceId) {
            case 1: {
                this.gridItems.data[0].endOne = 0;
                break;
            }
            case 2: {
                this.gridItems.data[0].endtwo = 0;
                break;
            }
            case 3: {
                this.gridItems.data[0].sideOne = 0;
                break;
            }
            case 4: {
                this.gridItems.data[0].sideTwo = 0;
                break;
            }
            case 5: {
                this.gridItems.data[0].top = 0;
                break;
            }
            case 6: {
                this.gridItems.data[0].bottom = 0;
                break;
            }
            default: {
                return false;
            }
        }
    }

    onCheckAll() {
        if (this.ischeckAll) {
            const spaceingItem = Object.assign({}, this.commonDatModel.itemSpacingModel);
            let itemSpacingId = this.gridItems.data.length > 0 ? this.gridItems.data[0].spacingId : null;
            this.gridItems.data = [spaceingItem];
            this.gridItems.data[0].spacingId = itemSpacingId;
            this.spaceCheckBox.isBottom = true;
            this.spaceCheckBox.isTop = true;
            this.spaceCheckBox.isEndOne = true;
            this.spaceCheckBox.isEndtwo = true;
            this.spaceCheckBox.isSideOne = true;
            this.spaceCheckBox.isSideTwo = true;
            this.onSetGridItemCheckbox();
        } else {
            this.onClearAllSpaces();
        }
    }

    onClearAllSpaces() {
        let itemSpacingId = this.gridItems.data.length > 0 ? this.gridItems.data[0].spacingId : null;
        this.gridItems.data = [Object.assign({}, this.commonDatModel.itemSpacingModel)];
        this.gridItems.data[0].spacingId = itemSpacingId;
        this.spaceCheckBox = Object.assign({}, this.commonDatModel.itemSpacingModel);
    }
}
